/*
 * Copyright © 2025. TapClicks Inc. All rights reserved.
 *
 * Author: Rajesh Chittampally
 */

import { InsightsHqRoute, InsightsHqPathName } from '@/modules/ta/insightshq/insightshq.constants';
import { InsightsHqRouteConfig } from '@/modules/ta/insightshq/InsightsHqRouteConfig';

export const router = InsightsHqRouteConfig.factory([
  {
    path: `/${InsightsHqRoute.INSIGHTS_HQ}`,
    name: InsightsHqPathName.INSIGHTS_HQ,
    component: () => import(/* webpackChunkName: "insightshq-page" */ './pages/InsightsHqPage.vue'),
  },
]);
